import { ProductFlagService } from '../../../../../../shared/ProductFlag.service';
import { getProductFlagValues } from '../../../../main/selectors/ProductSelectors';
import type { DimensionToProductsMapType } from './DimensionProductMapping';
import { DimensionProductMapping } from './DimensionProductMapping';

import type { ProductFlagValues } from '../../../../../../shared/ProductFlipperFlag.service';

export class DimensionClassifier {
  constructor(
    private dimensionProductMapping: DimensionToProductsMapType = DimensionProductMapping,
    private productFlagService: ProductFlagService = new ProductFlagService()
  ) {}

  /**
   * Determines whether a dimension is provisioned based on product flags and conditions.
   *
   * @param {string} dimension - The dimension to check.
   * @returns {boolean} - Returns true if the dimension is provisioned, otherwise false.
   */
  public isProvisioned(dimension: string): boolean {
    const entry = this.dimensionProductMapping.get(dimension);
    if (!entry || !entry.enabled) {
      return false;
    }

    const productFlags: ProductFlagValues = getProductFlagValues();

    return entry.condition(productFlags);
  }
}
